import { useAuth0 } from '@auth0/auth0-react'

import { Auth0User } from '@sparkai/shared-types'

import { useAuthStore } from '../stores/authStore'

export function useAuthenticatedUser() {
  const { user } = useAuth0<Auth0User>()
  const [profile, token] = useAuthStore((s) => [s.userProfile, s.token])
  return { auth0User: user, profile, token }
}
